import $ from "jquery";

export default function () {
    leftMenuScroll();

    function leftMenuScroll() {

        let menuBlock = '.left-menu-scroll';
        let beforeElementScroll = 100;

        if(!$(menuBlock).length) {
            return;
        }

        generateMenu();

        $(menuBlock).find("> ul > li").click(function (){
            let scrollPoint = $("h2[data-href='" + $(this).attr('data-href') + "']").offset().top - beforeElementScroll;
            $('body,html').animate({
                scrollTop: scrollPoint
            }, 300);
        })

        setTimeout(function (){
            onScrollHandle();
            $(window).scroll(function () {
                onScrollHandle();
            });
        },500);


        function onScrollHandle() {
            let currentScrollPos = $(document).scrollTop();
            $(menuBlock).find("> ul > li").each(function () {
                let curLink = $(this);
                let refElem = $("h2[data-href='" + $(this).attr('data-href') + "']");

                if (refElem.offset().top - beforeElementScroll - 20 <= currentScrollPos ) {
                    $(menuBlock).find("> ul > li").removeClass("active");
                    curLink.addClass("active");
                }
                else {
                    curLink.removeClass("active");
                }
            });
        }

        function generateMenu() {
            if($('.left-menu-scroll__title').length) {

                let ul = $("<ul></ul>");

                $('.left-menu-scroll__title').each(function (){
                    if(
                        $(this).attr('data-title-left') !== undefined &&
                        $(this).attr('data-title-left') !== false
                    ) {
                        let li = $("<li></li>");
                        li.attr('data-href', $(this).attr('data-href'));
                        li.html($(this).attr('data-title-left'));

                        ul.append(li);
                    }
                });

                $(menuBlock).append(ul);
            }
        }
    }
}
